<header class="header">
  <div class="flex items-center justify-between">
    <a routerLink="/" class="flex items-center gap-2 md:gap-4 min-w-0 no-underline">
      <div class="bg-light-blue-500 rounded-lg flex items-center justify-center p-3 py-2.5">
        <img src="/images/logo.svg" alt="AIDE Logo" width="24" height="32" class="h-5 w-4">
      </div>
      <h1 class="header-title truncate">Aflac Intelligent Document Extraction</h1>
    </a>

    <div class="header-nav flex-shrink-0">
      <nav class="flex items-center gap-6">
        <a routerLink="/workbench" routerLinkActive="text-light-blue-600 font-semibold" class="header-nav-item no-underline">Workbench</a>
        @if (isAdmin()) {
          <a routerLink="/admin/analytics" routerLinkActive="text-light-blue-600 font-semibold" class="header-nav-item no-underline">Analytics</a>
          <a routerLink="/admin/prompts" routerLinkActive="text-light-blue-600 font-semibold" class="header-nav-item no-underline">Prompts</a>
        }
        <a routerLink="/splitter" routerLinkActive="text-light-blue-600 font-semibold" class="header-nav-item no-underline">Splitter</a>
      </nav>

      <div class="relative ml-6">
        <button
          (click)="toggleDropdown()"
          class="flex items-center justify-center w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 transition-colors"
          aria-label="User menu">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </button>

        @if (dropdownOpen()) {
          <div class="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50">
            <div class="px-4 py-2 text-sm text-gray-700 border-b border-gray-200">
              {{ userInfo()?.name || userInfo()?.email || 'User' }}
            </div>
            <button
              (click)="logout()"
              class="w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">
              Logout
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</header>
